// skipcq: JS-W1028
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

import TapRatingBar from '../ratings/TapRatingBar';

function BeerProfileHeaderCard({ beerName, overallRating }) {
  return (
    <Card variant="outlined" sx={{ bgcolor: 'background.paper' }}>
      <CardContent
        sx={{
          p: { xs: 2, sm: 3 },
          '&:last-child': { pb: { xs: 2, sm: 3 } },
        }}
      >
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'minmax(0, 1fr) auto',
            columnGap: 1.5,
            alignItems: 'start',
          }}
        >
          <Typography
            variant="h5"
            component="h1"
            sx={{ fontFamily: 'Lora, Georgia, serif', fontWeight: 600 }}
          >
            {beerName}
          </Typography>
          <Box sx={{ justifySelf: 'end', pt: 0.25 }}>
            <TapRatingBar rating={overallRating} showNumeric showUnratedLabel />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}

BeerProfileHeaderCard.propTypes = {
  beerName: PropTypes.string.isRequired,
  overallRating: PropTypes.number,
};

export default BeerProfileHeaderCard;
